<template>
  <!-- NOTIFICATIONS -->
  <!--     v-on:click.native="clearUnread" -->
  <vs-dropdown
    vs-custom-content
    vs-trigger-click
    ref="feedbackDropdown"
    class="cursor-pointer"
  >
    <feather-icon
      icon="LifeBuoyIcon"
      class="cursor-pointer mt-1 sm:mr-6 mr-2"
    />

    <vs-dropdown-menu
      class="
        notification-dropdown
        news-dropdown
        dropdown-custom
        vx-navbar-dropdown
      "
    >
      <div
        class="
          notification-top
          text-center
          p-5
          bg-primary
          text-white
          opacity-75
        "
      >
        <h3 class="text-white">Need help or got feedback?</h3>
      </div>
      <component
        :is="scrollbarTag"
        ref="mainSidebarPs"
        class="scroll-area--nofications-dropdown scroll-area--news-dropdown p-0"
        style
        :settings="settings"
        :key="$vs.rtl"
      >
        <div class="p-4 text-center" v-if="hasSubmitted">
          <h4 class="mb-2">Thank you 🛟</h4>
          <p>Your ticket has been submitted</p>
          <p>
            We'll get back to you as soon as possible. Often within 24 work
            hours.
          </p>
          <a @click="hasSubmitted = false" class="cursor-pointer"
            >Click here to submit another ticket</a
          >
        </div>
        <div v-else class="p-4">
          <div class="flex justify-center">
            <img src="@/assets/images/support.png" style="width: 300px" />
          </div>

          <vs-input
            v-model="feedbackTopic"
            placeholder="What is it about?"
            class="mt-4 mb-3 w-full"
          />

          <vs-textarea
            v-model="feedbackComment"
            placeholder="Describe your feedback or issue"
            :style="{ height: '100px' }"
          />
          <label>Include URL</label>
          <vs-switch
            v-model="includeUrl"
            placeholder="Include my URL"
            class="mt-1 mb-2"
          />
          <vs-input
            v-if="includeUrl"
            v-model="feedbackUrl"
            placeholder="URL"
            disabled="true"
            class="mt-4 mb-3 w-full"
          />
          <vs-divider />
          <vs-button
            :disabled="!isValid"
            @click.stop="submitFeedback"
            class="w-full"
            color="primary"
            >Submit</vs-button
          ><!--  -->
        </div>
      </component>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import NewsArticle from "./News/NewsCard.vue";
import { mapGetters } from "vuex";
import { format } from "timeago.js";
import router from "@/router";
export default {
  components: {
    VuePerfectScrollbar,
  },
  data() {
    return {
      hasSubmitted: false,
      includeUrl: false,
      isSubmitting: false,
      feedbackTopic: "",
      feedbackComment: "",
      dropdownOpen: this.$refs.notificationDropdown
        ? this.$refs.notificationDropdown.vsDropdownVisible
        : false,
      format,

      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
    };
  },
  async mounted() {},
  computed: {
    isValid() {
      return this.feedbackTopic && this.feedbackComment && !this.isSubmitting;
    },
    feedbackUrl() {
      return window.location.href;
    },
    ...mapGetters({
      //news: "news/news",
    }),

    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
  methods: {
    async submitFeedback() {
      this.isSubmitting = true;
      
      const dto = {
        subject: this.feedbackTopic,
        description: this.feedbackComment,
        url: this.includeUrl ? this.feedbackUrl : "",
      };

      await this.$store.dispatch("feedback/submitFeedback", dto);
      this.hasSubmitted = true;
      this.isSubmitting = false;
      this.includeUrl = false;
      this.feedbackTopic = "";
      this.feedbackComment = "";
    },
  },
};
</script>

